<template>
    <header class="navBar">
		<van-icon v-if="show" name="arrow-left" size="22" color="#333333" @click="back" />
        <h3>{{title}}</h3>
    </header>
</template>

<script>
export default {
    name: "NavBar",
    data() {
        return {}
    },
    props: {
        // 导航文字
        title: {
            type: String,
            value: ""
		},
		show: {
			type: Boolean,
			value: true
		},
        // 返回路由路径
        path: {
            type: String,
            value: ""
        }
	},
    methods: {
        back() {
            if (this.path && this.path != "") {
                // 后期设定固定返回页面时传值使用
                this.$router.push(this.path);
            } else {
                this.$router.go(-1);
            }
        }
    }
}
</script>

<style lang="less" scoped>
.navBar {
    height: 42px;
	line-height: 42px;
	background: white;
	box-shadow: 0px .5px 0px 0px rgba(0, 0, 0, 0.08);
	position: relative;
	.van-icon{
		position: absolute;
		top: 10px;
		left: 10px;
	}
    > h3 {
		line-height: 42px;
		text-align: center;
		color: #222222;
		font-size: 18px;
        font-weight: 600;
        margin: 0;
    }
}
</style>
